export const PRINTFUL_PRODUCTS_SYNC_FIELDS_LIST: any = [
    {attribute: "id", label: "Id", cssClass: 'text-center'},
    {
        attribute: "isProductsFetchCompleted",
        label: "Is Products Fetch Completed",
        cssClass: 'text-center',
        isBoolean: true,
    },
    {
        attribute: "isVariantsFetchCompleted",
        label: "Is Variants Fetch Completed",
        cssClass: 'text-center',
        isBoolean: true,
    },
    {
        attribute: "isTemplatesFetchCompleted",
        label: "Is Templates Fetch Completed",
        cssClass: 'text-center',
        isBoolean: true,
    },
    {attribute: "totalBatches", label: "Total Batches", cssClass: 'text-center'},
    {attribute: "totalProducts", label: "Total Products", cssClass: 'text-center'},
    {attribute: "updatedOn", label: "Updated On", cssClass: 'text-center', isDate: true},
];


export const PRINTFUL_PRODUCTS_SYNC_INPUT_FIELDS: any = [
    {attribute: "id", label: "Id", type: 'text', group: 'detail', cssClass: ''},
    {
        attribute: "isProductsFetchCompleted",
        label: "Is Products Fetch Completed",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "isVariantsFetchCompleted",
        label: "Is Variants Fetch Completed",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "isTemplatesFetchCompleted",
        label: "Is Templates Fetch Completed",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {attribute: "totalBatches", label: "Total Batches", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "totalProducts", label: "Total Products", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "updatedOn", label: "Updated On", type: 'text', group: 'detail', cssClass: ''},
];

export const PRINTFUL_PRODUCTS_SYNC_BATCHES_FIELDS_LIST: any = [
    {attribute: "batchIndex", label: "Batch Index", cssClass: 'text-center'},
    {attribute: "variantStatus", label: "Variant Status", cssClass: 'text-center'},
    {attribute: "templateStatus", label: "Template Status", cssClass: 'text-center'},
    {attribute: "totalProducts", label: "Total Products", cssClass: 'text-center'},
];
